export function getPipelineStage(worker = {}) {
  const registrationStatus = String(
    worker.registrationStatus || ""
  ).toLowerCase();

  const onboardingStatus = String(
    worker.onboardingStatus || ""
  ).toLowerCase();

  const complianceStatus = String(
    worker.complianceStatus || ""
  ).toLowerCase();

  const workerStatus = String(
    worker.workerStatus || ""
  ).toLowerCase();

  const status = String(worker.status || "").toLowerCase();

  const workerOperationalState = String(
    worker.workerOperationalState || ""
  ).toUpperCase();

  const archived =
    status === "archived" ||
    worker.archived === true;

  const registrationApproved =
    registrationStatus === "approved" ||
    worker.registrationApproved === true ||
    worker.canAccessOnboarding === true;

  const approved =
    onboardingStatus === "approved" ||
    complianceStatus === "approved" ||
    workerStatus === "ready" ||
    workerOperationalState === "READY" ||
    worker.onboardingCompleted === true ||
    status === "active";

  const reviewQueue =
    onboardingStatus === "submitted" ||
    onboardingStatus === "pending_review" ||
    complianceStatus === "pending_review" ||
    workerStatus === "under_review";

  const onboarding =
    onboardingStatus === "onboarding" ||
    onboardingStatus === "missing_docs" ||
    onboardingStatus === "in_progress" ||
    onboardingStatus === "registered";

  const actionRequired =
    onboardingStatus === "action_required" ||
    onboardingStatus === "reupload_required" ||
    complianceStatus === "reupload_required" ||
    complianceStatus === "rejected" ||
    workerStatus === "action_required" ||
    workerStatus === "rejected" ||
    status === "action_required";

  if (archived) {
    return "archived";
  }

  if (actionRequired) {
    return "action_required";
  }

  if (approved) {
    return "approved";
  }

  if (reviewQueue) {
    return "review_queue";
  }

  if (registrationApproved || registrationStatus === "registered") {
    if (onboarding) {
      return "onboarding";
    }

    return "registered";
  }

  if (
    registrationStatus === "pending" ||
    registrationStatus === "invited"
  ) {
    return "invited";
  }

  if (
    !registrationStatus &&
    !onboardingStatus &&
    !workerStatus
  ) {
    return "invited";
  }

  return "onboarding";
}